<script>
import Layout from "../../layouts/main";
import Style from "@/views/layouts/style";
import PageHeader from "@/components/Page-header";
import appConfig from "@/../app.config";
import CheckModal from "@/components/CheckModal";
import medicionAusentismoAPI from "@/services/standards/medicionAusentismo/medicionAusentismoAPI";
import downloadFile from "@/utils/helpers/downloadFile";
import Swal from "sweetalert2";

export default {
  page: {
    title: "3.3.6 Medición del ausentismo por causa médica",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: {
    CheckModal,
    Layout,
    Style,
    PageHeader,
  },
  data() {
    const currentYear = new Date().getFullYear();
    return {
      title: "3.3.6 Medición del ausentismo por causa médica",
      items: [
        {
          text: "Estandares",
          href: "/forms/estandares",
        },
        {
          text: "3.3.6 Medición del ausentismo por causa médica",
          active: true,
        },
      ],

      years: [],
      meses: [
        "Enero", "Febrero", "Marzo", "Abril", "Mayo", "Junio",
        "Julio", "Agosto", "Septiembre", "Octubre", "Noviembre", "Diciembre"
      ],
      medicionAnual: {
        start_year: currentYear,
        end_year: currentYear,
      },
      medicionMensual: {
        year: currentYear,
      },
      chartOptions: {
        lineSmooth: false,
      },

      selected: null,
      showMonthlyGraph: null,
      graphMonthlyData: [],
      isGeneratingMonthly: false,
      monthlyTable: {},
      monthlyTotals: {
        totals: []
      },
      showAnnualGraph: null,
      graphAnnualData: [],
      isGenerating: false,

      companyID: this.$store.getters["company/getCompany"].id || null,
      classificationID: this.$store.getters["company/getCompany"].company_classification_id || null,
      user: this.$store.state.auth || null,
      token: this.$store.state.auth.user.token || null,
    }
  },
  computed: {
    buttonClass() {
      return this.isGenerating ? "btn-danger" : "btn-primary";
    },
    buttonText() {
      return this.isGenerating ? "Limpiar" : "Generar reporte";
    },
    buttonClassMonthly() {
      return this.isGeneratingMonthly ? "btn-danger" : "btn-primary";
    },
    buttonTextMonthly() {
      return this.isGeneratingMonthly ? "Limpiar" : "Generar reporte";
    },
  },
  methods: {
    allowAccess() {
      try {
        const item = this.itemData;
        if (item) {
          const classificationID = this.$store.getters["company/getCompany"].company_classification_id || null;

          if (classificationID === 1 && item.obligatory_UPA === 1) {
            return true;
          } else if (classificationID === 2 && item.obligatory_groupI === 1) {
            return true;
          } else if (classificationID === 3 && item.obligatory_groupII === 1) {
            return true;
          } else if (classificationID === 4 && item.obligatory_groupIII === 1) {
            return true;
          } else {
            return false;
          }
        } else {
          return false;
        }
      } catch (error) {
        console.log(error);
        return false;
      }
    },
    getRole(name, roles) {
      let role = this.$store.state.auth.info.role ? this.$store.state.auth.info.role : null;
      if (role) {
        if (roles) {
          role = roles.includes(role) ? true : false;
        }
        else {
          role = role === 1 || role === 2 || role === 3 || role === 4 || role === 5 || role === 6 || role === 7 || role === 8;
        }
        const permissions = this.$store.state.auth.info.permissions;
        const enabled = permissions.find(
          (permission) => permission.name === name
        );
        return enabled && role ? true : false;
      }
      else {
        return false;
      }
    },
    rangeYear() {
      const max = 2040;
      const min = 2019;

      for (let i = min; i <= max; i++) {
        this.years.push(i);
      }
      return this.years
    },

    getMonthlyTotals() {
      medicionAusentismoAPI
        .getMonthlyTotals(this.companyID, {
          year: this.medicionMensual.year,
          pediod: "mensual",
        })
        .then((response) => {
          this.monthlyTotals.totals = response.totals;

          const normalizedData = {};
          const meses = [
            "Enero", "Febrero", "Marzo", "Abril", "Mayo", "Junio",
            "Julio", "Agosto", "Septiembre", "Octubre", "Noviembre", "Diciembre"
          ];

          // Iterar por los meses y normalizar los datos
          meses.forEach((mes) => {
            const mesKey = mes.toLowerCase(); // Clave del mes en minúsculas
            const mesData = response.data[mesKey]; // Datos del mes desde la respuesta

            if (mesData && typeof mesData === "object") {
              // Convertir el objeto a un array y asignarlo
              normalizedData[mes] = Object.values(mesData);
            } else {
              // Si no hay datos o no es un objeto, inicializar como array vacío
              normalizedData[mes] = [];
            }
          });

          // Asignar los datos normalizados a monthlyTable
          this.monthlyTable = normalizedData;
        })
        .catch((error) => {
          console.log(error);
        });
    },

    async reportAnual() {
      try {
        await medicionAusentismoAPI.getMedicionAusentismoAnual(this.companyID, this.medicionAnual)
          .then((response) => {
            const dataResponse = response.data;

            // Inicializa graphAnnualData
            this.graphAnnualData = {
              labels: [],
              series: [[]],
            };

            // Itera sobre dataResponse y agrega los datos a graphAnnualData
            for (let i = 0; i < dataResponse.length; i++) {
              this.graphAnnualData.labels.push(dataResponse[i]['Año']);
              this.graphAnnualData.series[0].push(dataResponse[i]['Ausentismo_causa_medica']);
            }
          })
          .catch((error) => {
            console.log(error);
          });
      } catch (error) {
        console.error('Error fetching annual report data:', error);
      }
    },

    async reportMensual() {
      try {
        await medicionAusentismoAPI.getMedicionAusentismoMensual(this.companyID, this.medicionMensual)
          .then((response) => {
            const dataResponse = response.data;
            // // Inicializa graphMonthlyData
            this.graphMonthlyData = {
              labels: [],
              series: [[]],
            };

            // Array con los nombres de los meses en orden
            const monthsOrder = [
              'enero', 'febrero', 'marzo', 'abril', 'mayo', 'junio',
              'julio', 'agosto', 'septiembre', 'octubre', 'noviembre', 'diciembre'
            ];

            // Itera sobre monthsOrder y asigna los valores correspondientes
            for (let month of monthsOrder) {
              this.graphMonthlyData.labels.push(month.charAt(0).toUpperCase() + month.slice(1)); // Capitaliza el primer carácter
              this.graphMonthlyData.series[0].push(dataResponse[month] || 0); // Asigna el valor o 0 si no existe
            }
          })
          .catch((error) => {
            console.log(error);
          });
      } catch (error) {
        console.error('Error fetching monthly report data:', error);
      }
    },

    toggleReport() {
      if (this.isGenerating) {
        this.resetForm();
      } else {
        this.generateReport();
      }
    },

    toggleReportMonthly() {
      if (this.isGeneratingMonthly) {
        this.resetFormMonthly();
      } else {
        this.generateReportMonthly();
      }
    },

    generateReport() {
      this.showAnnualGraph = true;
      this.isGenerating = true;
      this.$emit("generate-report");
      this.reportAnual();
    },

    generateReportMonthly() {
      this.showMonthlyGraph = true;
      this.isGeneratingMonthly = true;
      this.$emit("generate-report");
      this.reportMensual();
      this.getMonthlyTotals();
    },

    resetForm() {
      this.medicionAnual.start_year = new Date().getFullYear();
      this.medicionAnual.end_year = new Date().getFullYear();
      this.showAnnualGraph = false;
      this.isGenerating = false;
      this.$emit("reset-form");
    },

    resetFormMonthly() {
      this.medicionMensual.year = new Date().getFullYear();
      this.showMonthlyGraph = false;
      this.isGeneratingMonthly = false;
      this.$emit("reset-form");
    },

    async print() {
      try {
        const url = await medicionAusentismoAPI.getExcel(
          this.companyID,
          this.medicionMensual.year
        );
        if (!url) return;
        // Se descarga por fetch y no por navegacion directa: el endpoint esta
        // detras del middleware can.reports, que exige el header X-User-Role.
        await downloadFile(
          url,
          `Medicion_ausentismo_causa_medica_${this.medicionMensual.year}.xlsx`
        );
      } catch (error) {
        console.log(error);
        Swal.fire({
          title: "¡ERROR!",
          text: error.message || "No se pudo descargar el archivo.",
          icon: "error",
          confirmButtonClass: "btn btn-confirm mt-2",
        });
      }
    },

    goPage(page) {
      window.location.href = page;
    },
    goBack() {
      this.$router.go(-1);
    },
  },
  mounted() {
    this.rangeYear();
  },
}

</script>
<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <div class="row animated animatedFadeInUp fadeInUp">
      <div class="col-md-12 m-0 p-0">
        <div class="card">
          <div class="card-body">

            <div class="row">
              <div class="col-md-6 col-sm-12">
                <CheckModal>
                  <p class="text-justify">
                    Este indicador mide la pérdida de días programados de trabajo en el mes por incapacidad médica.
                  </p>
                  <p class="text-justify">
                    Los días programados de trabajo al mes corresponden a la cantidad de días laborales en el mes por el
                    número de trabajadores.
                  </p>
                  <p class="text-justify">
                    El responsable de la implementación deberá definir la meta mensual y anual, además el responsable de
                    la medición y las personas que deben conocer el resultado.
                  </p>
                </CheckModal>
              </div>
              <div class="col-6 text-right m-b-0">
                <button @click="goPage(`/forms/estandares/${companyID}/medicion-ausentismo`)"
                  class="btn btn-primary mx-1">
                  <span class="btn-label"> </span> Parametrizar periodos
                </button>
                <div class="btn btn-secondary m-l-5 ml-1" id="back" @click="goBack">
                  <i class="fas fa-arrow-left"></i>
                  <b-tooltip target="back" placement="left"> Volver </b-tooltip>
                </div>
              </div>
            </div>

            <hr />

            <div class="row pt-3">
              <b-form-group label="Seleccionar Periodicidad" label-for="¿Evaluada el ultimo año?" inline
                class="col-sm-4 pl-3">
                <label class="mr-2 pl-sm-2 pl-md-0"> Mensual </label>
                <input type="radio" :value="2" class="mb-2 mr-sm-2 mb-sm-0" label="incidente" v-model="selected" />
                <label class="mr-2"> Anual </label>
                <input type="radio" style="color: #666" :value="1" class="mb-2 mr-sm-2 mb-sm-0" label="accidente"
                  v-model="selected" />
              </b-form-group>
            </div>

            <form class="row pt-3 pl-2" v-if="selected === 2" @submit.prevent="reportMensual">
              <b-form-group id="cycle" label-for="cycle" class="col-md-2 px-2" label="Seleccione el año">
                <b-form-select class="col-md-8 form-control" v-model="medicionMensual.year">
                  <b-form-select-option v-for="item in years" :value="item" v>
                    {{ item }}
                  </b-form-select-option>
                </b-form-select>
              </b-form-group>

              <div class="col-md-6 col-sm-12">
                <button @click="toggleReportMonthly" type="button" class="btn mt-3" :class="buttonClassMonthly">
                  {{ buttonTextMonthly }}
                </button>
              </div>

              <div class="col-md-4 col-sm-12 text-right m-b-0 d-flex justify-content-center align-items-center">
                <button @click="print" type="button" class="btn btn-primary mx-1" id="tooltip">
                  <span class="btn-label"><i class="bx bx-download"></i></span>Descargar tabla a excel
                </button>
                <b-tooltip target="tooltip" placement="left">
                  Descargar reporte
                </b-tooltip>
              </div>

              <div v-if="showMonthlyGraph" class="form-row col-12 pt-2 px-4 d-flex justify-content-center">
                <div class="col-8">
                  <div class="row d-flex justify-content-center text-center">
                    <div class="pt-4 col-md-6 col-sm-12">
                      Número de colaboradores:
                      {{ this.monthlyTotals.totals ? this.monthlyTotals.totals.numero_colaboradores : 0 }}
                    </div>
                    <div class="pt-4 col-md-6 col-sm-12">
                      Número de incapacidades:
                      {{ this.monthlyTotals.totals ? this.monthlyTotals.totals.cantidad_incapacidad : 0 }}
                    </div>
                  </div>
                  <div class="row d-flex justify-content-center text-center">
                    <div class="pt-4 col-md-6 col-sm-12">
                      Número de días de incapacidad:
                      {{ this.monthlyTotals.totals ? this.monthlyTotals.totals.dias_incapacidad : 0 }}
                    </div>
                    <div class="pt-4 col-md-6 col-sm-12">
                      Accidentes de trabajo:
                      {{ this.monthlyTotals.totals ? this.monthlyTotals.totals.accidentes_trabajo : 0 }}
                    </div>
                  </div>
                  <div class="row d-flex justify-content-center text-center">
                    <div class="pt-4 col-md-6 col-sm-12">
                      Enfermedad general:
                      {{ this.monthlyTotals.totals ? this.monthlyTotals.totals.enfermedad_general : 0 }}
                    </div>
                    <div class="pt-4 col-md-6 col-sm-12">
                      Enfermedad laboral
                      {{ this.monthlyTotals.totals ? this.monthlyTotals.totals.enfermedad_laboral : 0 }}
                    </div>
                  </div>

                  <div class="row text-center">
                    <div class="col-md-12 pt-4 col-sm-12">
                      Ausentismo por causa médica: ((Número de días de incapacidad) / (Número de días laborales*total de
                      trabajadores))*100
                    </div>
                  </div>
                </div>
              </div>

              <div v-if="showMonthlyGraph" class="form-row col-12 pt-2 tablaExcel">
                <div class="table-responsive pt-4 px-5" v-if="getRole('Consultar')">
                  <table class="pt-2 table border-bottom divide-y divide-gray-200 table-bordered rounded">
                    <thead class="bg-primary text-light">
                      <tr>
                        <th class="text-center align-middle">Periodo</th>
                        <th class="text-center align-middle">Colaborador</th>
                        <th class="text-center align-middle">Tipo</th>
                        <th class="text-center align-middle">Dias incapacidad</th>
                        <th class="text-center align-middle">Diagnóstico</th>
                        <th class="text-center align-middle">Prórroga</th>
                      </tr>
                    </thead>
                    <tbody class="bg-white divide-y divide-gray-200">
                      <tr v-for="mes in meses" :key="mes">
                        <!-- Mostrar el nombre del mes -->
                        <td class="bg-primary text-center text-white align-middle">
                          {{ mes }}
                        </td>

                        <!-- Colaborador -->
                        <td v-if="monthlyTable[mes]?.length > 0" class="text-center align-middle">
                          <div v-for="dato in monthlyTable[mes]" :key="dato.colaborador">
                            <p>{{ dato.colaborador }}</p>
                          </div>
                        </td>
                        <td v-else class="text-center align-middle">0</td>

                        <!-- Tipo de incapacidad -->
                        <td v-if="monthlyTable[mes]?.length > 0" class="text-center align-middle">
                          <div v-for="dato in monthlyTable[mes]" :key="dato.tipo_incapacidad">
                            <p>{{ dato.tipo_incapacidad }}</p>
                          </div>
                        </td>
                        <td v-else class="text-center align-middle">0</td>

                        <!-- Días de incapacidad -->
                        <td v-if="monthlyTable[mes]?.length > 0" class="text-center align-middle">
                          <div v-for="dato in monthlyTable[mes]" :key="dato.dias_incapacidad">
                            <p>{{ dato.dias_incapacidad }}</p>
                          </div>
                        </td>
                        <td v-else class="text-center align-middle">0</td>

                        <!-- Diagnóstico -->
                        <td v-if="monthlyTable[mes]?.length > 0" class="text-center align-middle">
                          <div v-for="dato in monthlyTable[mes]" :key="dato.diagnostico">
                            <p>{{ dato.diagnostico }}</p>
                          </div>
                        </td>
                        <td v-else class="text-center align-middle">0</td>

                        <!-- Prórroga -->
                        <td v-if="monthlyTable[mes]?.length > 0" class="text-center align-middle">
                          <div v-for="dato in monthlyTable[mes]" :key="dato.prorroga">
                            <p>{{ dato.prorroga }}</p>
                          </div>
                        </td>
                        <td v-else class="text-center align-middle">0</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>

              <div v-if="showMonthlyGraph" class="col-lg-12 pt-3">
                <div class="tittle-graph"><strong>Esta gráfica representa el resultado del ausentismo Mensual de la
                  accidentalidad</strong></div>
                <div class="card">
                  <div class="card-body" dir="ltr">
                    <h4 class="header-title">Gráfica ausentismo mensual</h4>
                    <ul>
                      <li style="color: #00707f">Ausentismo mensual</li>
                    </ul>
                    <p class="sub-header"></p>

                    <Chartist ratio="ct-chart" :data="graphMonthlyData" :options="chartOptions" type="Line"></Chartist>
                  </div>
                </div>
              </div>
            </form>

            <form class="row pt-3 pl-2" v-if="selected === 1" @submit.prevent="reportAnual">
              <b-form-group id="cycle" label-for="cycle" class="col-md-2 px-2" label="Inicio">
                <b-form-select required class="col-md-8 form-control" v-model="medicionAnual.start_year">
                  <b-form-select-option v-for="item in years" :value="item">
                    {{ item }}
                  </b-form-select-option>
                </b-form-select>
              </b-form-group>
              <b-form-group id="cycle" label-for="cycle" class="col-md-2 px-2" label="Fin">
                <b-form-select required class="col-md-8 form-control" v-model="medicionAnual.end_year">
                  <b-form-select-option v-for="item in years" :value="item">
                    {{ item }}
                  </b-form-select-option>
                </b-form-select>
              </b-form-group>

              <div class="col-md-6 col-sm-12">
                <button @click="toggleReport" type="button" class="btn mt-3" :class="buttonClass">
                  {{ buttonText }}
                </button>
              </div>

              <div v-if="showAnnualGraph" class="col-lg-12 pt-3">
                <div class="tittle-graph"><strong>Esta gráfica representa el resultado del ausentismo Anual de la
                  accidentalidad</strong></div>
                <div class="card">
                  <div class="card-body" dir="ltr">
                    <h4 class="header-title">Gráfica ausentismo anual</h4>
                    <ul>
                      <li style="color: #00707f">Ausentismo anual</li>
                    </ul>
                    <p class="sub-header"></p>

                    <Chartist ratio="ct-chart" :data="graphAnnualData" :options="chartOptions" type="Line"></Chartist>
                  </div>
                </div>
              </div>

            </form>

          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>
<style scoped>
.background-modal {
  background-color: transparent !important;
  border: none;
}

.bg-red {
  background-color: red;
  color: white;
}

.tittle-graph {
  font-size: 1.2rem;
  font-weight: bold;
  color: #00707f;
}
</style>